module.exports = __webpack_public_path__ + "img/9788991216457.20e5cc1e.jpg";